import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGoldMedal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGoldMedal"><Path d="M16.5 23.2812L12 22.0303L7.5 23.2812V18.3984C8.84659 19.1005 10.3763 19.5 12 19.5C13.6237 19.5 15.1534 19.1005 16.5 18.3984V23.2812Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.5C16.5563 1.5 20.25 5.19365 20.25 9.75C20.25 14.3063 16.5563 18 12 18C7.44365 18 3.75 14.3063 3.75 9.75C3.75 5.19365 7.44365 1.5 12 1.5ZM9.44727 7.02734V8.35547L11.3184 7.16016H11.3652V13.75H12.8145V5.75H11.4355L9.44727 7.02734Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGoldMedal;
